import { PULSE_COLORS } from './pulseConfig.js'
import { colorFromName, getInitials } from './pulseHelpers.js'

const PALETTE = ['#3B82F6', '#EC4899', '#10B981', '#F59E0B', '#8B5CF6', '#06B6D4', '#EF4444', '#6366F1']

export default function Leaderboard({ members, limit = 8, headerAction }) {
    const top = members.filter((m) => m.qaTeam && m.score > 0).slice(0, limit)
    const max = top[0]?.score ?? 1

    return (
        <div
            style={{
                background: PULSE_COLORS.cardBg,
                borderRadius: '12px',
                padding: '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                }}
            >
                <h3
                    style={{
                        color: PULSE_COLORS.text,
                        fontWeight: 600,
                        fontSize: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                    }}
                >
                    🏅 Leaderboard
                </h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '11px', color: PULSE_COLORS.textMuted }}>Ranked by quality score</span>
                    {headerAction}
                </div>
            </div>

            {top.length === 0 ? (
                <p style={{ fontSize: '13px', color: PULSE_COLORS.textMuted }}>No activity in the selected window.</p>
            ) : (
                <ul
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                    }}
                >
                    {top.map((m, idx) => {
                        const color = colorFromName(m.name, PALETTE)
                        const widthPct = Math.max(8, Math.round((m.score / max) * 100))
                        return (
                            <li key={m.name} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <span
                                    style={{
                                        width: '24px',
                                        textAlign: 'center',
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        color: PULSE_COLORS.textSubtle,
                                    }}
                                >
                                    {idx + 1}
                                </span>
                                <span
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#fff',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        flexShrink: 0,
                                        backgroundColor: color,
                                    }}
                                >
                                    {getInitials(m.name)}
                                </span>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '8px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                color: PULSE_COLORS.text,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {m.name}
                                            {m.badges.length > 0 && (
                                                <span
                                                    style={{
                                                        marginLeft: '4px',
                                                        fontSize: '11px',
                                                        color: PULSE_COLORS.textMuted,
                                                    }}
                                                >
                                                    {m.badges.map((b) => b.emoji).join(' ')}
                                                </span>
                                            )}
                                        </span>
                                        <span
                                            style={{
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                color: PULSE_COLORS.text,
                                            }}
                                        >
                                            {m.score} pts
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            fontSize: '11px',
                                            color: PULSE_COLORS.textMuted,
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <span>🐛 {m.bugsCreated} filed</span>
                                        <span>✅ {m.bugsClosed} closed</span>
                                        <span>📋 {m.qaStoriesClosed} QA</span>
                                        <span>🎯 {m.closerCount} done</span>
                                        <span>🤖 {m.storiesAutomated} auto</span>
                                        <span>🦁 {m.mergeRequests} MRs</span>
                                        <span>⚙️ {m.totalCommits} commits</span>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '4px',
                                            height: '6px',
                                            background: PULSE_COLORS.bgInner,
                                            borderRadius: '3px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '100%',
                                                borderRadius: '3px',
                                                width: `${widthPct}%`,
                                                backgroundColor: color,
                                                transition: 'all 0.2s',
                                            }}
                                        />
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            )}
        </div>
    )
}
